import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AffectionDossierTableMetierService} from './affection-dossier-table.metier.service';
import {Autowired} from '@angular-ru/autowired';
import {SgiListLayoutComponent} from '@shared/behaviors/list-layout/sgi/sgi-list-layout.component';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-affection-dossier-table',
  templateUrl: './affection-dossier-table.component.html'
})

export class AffectionDossierTableComponent extends SgiListLayoutComponent implements OnInit {
  @Autowired() recuperationListeDonneesMetier: AffectionDossierTableMetierService;
  @Autowired() metierService: AffectionDossierTableMetierService;

  @Input() modalAssureSelected: any;
  @Input() responseAffections: any;
  formGroup: FormGroup;
  typeRechercheCombo: any[] = [];
  placeholderInputSearch: string;
  @Output() responseAffectionsEvent = new EventEmitter<any>();

  constructor() {
    super();
    this.cols = [
      {field: 'codeAffection', header: 'Code Affection'},
      // {field: 'libelleAffection', header: 'Libelle'},
      // {field: 'libelleTypeAffection', header: 'Type Affection'},
      {field: 'estExclu', header: 'Est Exclu'},
      {field: 'datePrestation', header: 'Date Prestation', type: () => 'date'},
    ];
    this.tableActions = [];
    this.notRowActions = [];
  }

  ngOnInit(): void {
    this.initialiserTypeRechercheCombo();

    this.initFormulaire();

    this.formatTableListAddIndex(this.responseAffections);
  }

  /**
   * Définition des arguments
   */
  defineArgs(): void {
    super.defineArgs();
    const arg = {...this.args};
    this.args = {...arg};
  }

  recuperationDonnees(data?: any) {
    const da = {...this.args, lazyLoadEvent: data, successMute: true, assure: this.modalAssureSelected};
    this.args = {...da};
    // tslint:disable-next-line:max-line-length
    this.metierService.requeteRecuperationListeDonnees(this.getAllRequestParam(), {...this.args}).subscribe((r_Affections) => {
      const responseAffections = r_Affections.body;

      this.formatTableListAddIndex(responseAffections);
      this.responseAffectionsEvent.emit(r_Affections.body);
    });
  }

  formatTableListAddIndex(responseData) {
    if (responseData === undefined) {
      this.dataSource = [];
      this.totalRecords = 0;
      return;
    }
    this.dataSource = responseData.items;
    this.totalRecords = responseData.count;
    if (this.dataSource && this.dataSource.length > 0) {
      this.dataSource.forEach((dat, index) => {
        dat.id_key = index + 1;
      });
    }
  }

  initFormulaire() {
    this.formGroup = this.metierService.initialiserFormulaire(null);
  }

  initialiserTypeRechercheCombo() {
    this.placeholderInputSearch = 'Rechercher';
    this.typeRechercheCombo = [
      { label: 'Code affection', value: 'code_affection'},
      { label: 'Libelle', value: 'libelle'},
      { label: 'Type affection', value: 'type_affection'},
      { label: 'Date prestation', value: 'date_prestation'},
    ];
  }

  handleChangeTypeRecherche(event: any) {
    if (event.value === null) {
      this.placeholderInputSearch = 'Rechercher';

      this.formGroup.patchValue({ inputSearch: null });

      // fonction de recherche assuré avec les valeurs null
      this.recuperationDonnees();
    }

    if (event.value === 'code_affection') {
      this.placeholderInputSearch = 'Rechercher par code affection';
    }
    if (event.value === 'libelle') {
      this.placeholderInputSearch = 'Rechercher par libelle';
    }
    if (event.value === 'type_affection') {
      this.placeholderInputSearch = 'Rechercher par type affection';
    }
    if (event.value === 'date_prestation') {
      this.placeholderInputSearch = 'Rechercher par date';
    }

    this.formGroup = this.metierService.initialiserFormulaire(this.formGroup.getRawValue());
  }

  recherchePrestation(event) {
    if (this.formGroup.getRawValue().selectTypeSearch === null) { return false; }

    // fonction de recherche assuré avec les valeurs entrées
    this.recuperationDonnees();
  }

}
